import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveAccessTokens } from '@ecp/common/src/utils/utils';

import authApi from '@fo-apis/common/authApi';

const GuestRoutes = () => {
  const navigate = useNavigate();

  const guestLogin = useCallback(async () => {
    const {
      data: { guestAccessToken },
    } = await authApi.guestLogin({});

    if(guestAccessToken) {
      saveAccessTokens(guestAccessToken);
      sessionStorage.removeItem('guest-move-page');
      navigate(0);
    } else {
      return false;
    }
  }, []);

  useEffect(() => {
    (async () => guestLogin())();
  }, [guestLogin]);

  return <></>;
};

export default GuestRoutes;
